<template>
  <div class="editCube">
    <div>{{title}} <button v-if="!edit" class="editBtn" @click="edit=true"></button></div>
    <p>
      單時段僅接受<input type="text" v-model.number="data" :disabled="!edit">組預約
    </p>
    <div class="btns" v-if="edit">
      <button class="cancel" @click="edit=false">取消</button>
      <button class="confirm" @click="udpateData">儲存</button>
    </div>
  </div>
</template>

<script>
import { getapi, postapi } from '../store/fetch'
export default {
  props: ['title'],
  data () {
    return {
      keyname: 'babyBookLimitation',
      edit: false,
      data: 1
    }
  },
  async mounted () {
    this.getdata()
  },
  methods: {
    async getdata () {
      const data = await getapi(`selections/${this.keyname}`)
      if (data === false) {
        const data = await postapi(`selections/${this.keyname}`, { key: 'value', data: this.data })
        this.data = parseInt(data)
      } else {
        this.data = parseInt(data)
      }
    },
    async udpateData () {
      const data = await postapi(`selections/${this.keyname}`, { key: 'value', data: this.data })
      this.data = parseInt(data)
      this.edit = false
    }
  }

}
</script>

<style lang="scss" scoped>
.editCube {
  margin: 0;
  margin-bottom: 20px;
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 9px;
  textarea, p {
    margin: 0;
    height: fit-content;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 67px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: -webkit-fill-available;
    input {
      width: 100px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 3px;
      border: 1px solid var(--color-border);
      margin-inline: 9px;
      text-align: center;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 900;
      font-size: 18px;
      text-align: center;
      letter-spacing: 0.1em;
      color: var(--color-confirm);
    }
  }
  &>div:nth-child(1) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(./pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}

</style>
